
import React from 'react';

import { translate } from '../../../base/i18n';

type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Custom header of the {@code ConfigureYourMeeting}.
 *
 * @returns {React$Element<any>}
 */
function Header({ t }: Props) {
    return (
        <>
            <div className = 'rows'>
                <div className = 'col-m-12'>
                    <div className = 'embed-meeting-dialog-header1'>
                        Configure Your Meeting
                    </div>
                </div>
            </div>
            <div
                className = 'rows'>
                <div className = 'col-m-6'>
                    <div className = 'embed-meeting-dialog-header2'>
                        { t('security.securityOptions') }
                    </div>
                </div>
                <div className = 'col-m-6'>
                    <div className = 'embed-meeting-dialog-header2'>
                        { t('addPeople.inviteMorePrompt') }
                    </div>

                </div>

            </div>
        </>
    );
}

export default translate(Header);
